import { action } from 'satcheljs';

import type { AccountSource } from '../store/schema/AccountSourceList';

export interface ON_SHARED_SOURCES_CHANGEDActionMessage {
    updatedAccount: AccountSource;
}
const defaultExport: (updatedAccount: AccountSource) => ON_SHARED_SOURCES_CHANGEDActionMessage =
    action(
        'ON_SHARED_SOURCES_CHANGED',
        (updatedAccount: AccountSource): ON_SHARED_SOURCES_CHANGEDActionMessage => ({
            updatedAccount,
        })
    );
export default defaultExport;
